export default {
  "path": "/demo/operate-index",
  "meta": {
    "name": "demo-按钮组组件",
    "title": "Operate 按钮组组件",
    "isComponentDoc": true,
    "category": "Basic"
  }
};